import "@formatjs/intl-durationformat/polyfill";
import "@fontsource-variable/inter";
import "@fontsource-variable/unbounded";
import "@fontsource/fanwood-text";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "@backpac/monica/style";

import App from "./App";

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
